import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class SharedForm extends Component {
  static propTypes = {
    authenticityToken: PropTypes.string.isRequired,
    actionUrl: PropTypes.string.isRequired,
    methodType: PropTypes.string,
    formAttrs: PropTypes.object
  }

  static defaultProps = {
    formAttrs: {}
  }

  _formAttrs () {
    const className = `simple_form form ${this.props.formAttrs.className}`
    return Object.assign(this.props.formAttrs, {
      className: className
    })
  }

  render () {
    return (
      <form noValidate
        {...this._formAttrs()}
        id={this.props.id || ''}
        action={this.props.actionUrl}
        acceptCharset='UTF-8'
        method={this.props.methodType}>

        <input name='utf8' type='hidden' value='✓' />
        <input type='hidden' name='authenticity_token' value={this.props.authenticityToken} />

        {this.props.children}
      </form>
    )
  }
}
